import Box from '@mui/material/Box';
import { Link as RouterLink } from 'react-router';

import logo from '@/assets/brand/kabex-logo.png?w=80;160;240&format=webp;png&as=picture';
import { company } from '@/config/company';

import { AppImage } from './AppImage';

/** Brand mark, linking home. `height` is the rendered height in px. */
export function Logo({ height = 52, priority = false }: { height?: number; priority?: boolean }) {
  const width = Math.round((height * logo.img.w) / logo.img.h);
  return (
    <Box
      component={RouterLink}
      to="/"
      aria-label={`${company.brandName} home`}
      sx={{ display: 'inline-flex', flexShrink: 0, lineHeight: 0 }}
    >
      <AppImage
        picture={logo}
        alt=""
        priority={priority}
        sizes={`${width}px`}
        style={{ height, width }}
      />
    </Box>
  );
}
